import { isNull, lt, or, type SQL } from "@repo/fika-db/drizzle"
import { posts } from "@repo/fika-db/schema"

const SPAM_SCORE = 2

export const spamCondition = or(
  lt(posts.spam_score, SPAM_SCORE),
  isNull(posts.spam_score),
) as SQL<unknown>

export function isPostSpam(post: { spam_score?: number | null }) {
  return (post.spam_score ?? 0) > SPAM_SCORE
}
